<script lang="ts">
	import type { PoiScheme } from '../../types';
	import ButtonAddToItinerary from '$lib/components/atoms/button/ButtonAddToItinerary.svelte';
	import Link from '$lib/components/atoms/link/Link.svelte';
	import TheForkWidget from '$lib/components/theFork/TheForkWidget.svelte';
	import * as m from '$paraglide/messages';

	interface Props {
		scheme?: PoiScheme;
		isFloating?: boolean;
		bookUrl?: string;
		showItineraryButton?: boolean;
		theForkUrl?: string;
		hasShadow?: boolean;
		showLearnMoreButton?: boolean;
		learnMoreLabel?: string;
		infoUrl?: string;
		onItineraryClick?: () => void;
		onLearnMoreClick?: () => void;
		onBookClick?: () => void;
	}

	const {
		scheme,
		isFloating = false,
		bookUrl,
		showItineraryButton = true,
		theForkUrl,
		hasShadow = true,
		showLearnMoreButton = false,
		learnMoreLabel,
		infoUrl,
		onItineraryClick,
		onLearnMoreClick,
		onBookClick,
	}: Props = $props();

	function getDynamicClasses(isFloating: boolean, hasShadow: boolean) {
		const classes = isFloating ? 'bg-neutral-weak md:bg-neutral-weakest shadow-first-inverted' : '';
		return hasShadow ? `${classes} p-2 md:rd-2` : classes;
	}

	const dynamicClasses = $derived(getDynamicClasses(isFloating, hasShadow));
</script>

<div class={['flex flex-row gap-2 items-center bg-neutral-weakest', dynamicClasses]}>
	{#if theForkUrl}
		<TheForkWidget class="" size="md" url={theForkUrl} onBookClick={() => onBookClick?.()} />
	{:else if bookUrl && !showLearnMoreButton}
		<Link
			icon={scheme}
			label={m.poi_actions__book()}
			button="filled"
			size="md"
			href={bookUrl}
			target="_blank"
			rel="external"
			onclick={() => onBookClick?.()}
		/>
	{/if}
	{#if showItineraryButton}
		<ButtonAddToItinerary
			onclick={() => onItineraryClick?.()}
			variant={bookUrl && !showLearnMoreButton ? 'outline' : 'filled'}
		/>
	{/if}
	{#if showLearnMoreButton && bookUrl}
		<Link
			icon="open-in-new"
			label={learnMoreLabel}
			button="outline"
			size="md"
			href={bookUrl}
			target={scheme === 'hotel' ? '_self' : '_blank'}
			rel="external"
			onclick={() => onLearnMoreClick?.()}
		/>
	{/if}
	{#if infoUrl}
		<Link
			icon="open-in-new"
			iconPosition="right"
			label={m.poiCard__seeDetails()}
			button="outline"
			color="light"
			size="md"
			href={infoUrl}
			target="_blank"
			rel="external"
			onclick={() => onLearnMoreClick?.()}
		/>
	{/if}
</div>
